import { splice } from './strings';

function regularNumberedListOneLine(string) {
  let result = string;
  const numberedList = string.match(/^([ ]{4})*[0-9]*\.[ ]{1,}.*/g);

  if (numberedList) {
    const numberListTag = '. ';
    const indexOfNumberList = string.indexOf(numberListTag, numberedList[0].index);
    const blankMatch = string.substring(indexOfNumberList).match(/^\.[ ]{1,}/);

    if (blankMatch) {
      const extraBlankLength = blankMatch[0].length - numberListTag.length;
      if (extraBlankLength > 0) {
        result = splice(string, indexOfNumberList + 1, extraBlankLength);
      }
    }
  }

  return result;
}

function regularNumberedListMultipleLines(string) {
  const lines = string.split('\n');
  let wholeStrings = '';

  lines.forEach((line, index) => {
    const regularLine = regularNumberedListOneLine(line);
    if (index !== lines.length - 1) {
      wholeStrings += `${regularLine}\n`;
    } else {
      wholeStrings += regularLine;
    }
  });

  return wholeStrings;
}

export { regularNumberedListOneLine, regularNumberedListMultipleLines };
